/** Encode a skill's scope+name into a single URL-safe path segment. */
export function encodeSkillRef(scope: string, name: string): string {
  return `${scope}--${name}`;
}

/** Decode a skillRef path segment back to scope and name. */
export function decodeSkillRef(ref: string): { scope: string; name: string } {
  const idx = ref.indexOf('--');
  if (idx === -1) return { scope: '', name: ref };
  return { scope: ref.slice(0, idx), name: ref.slice(idx + 2) };
}
